module.exports = __webpack_public_path__ + "static/media/icon2.36bf3493.svg";